// extracted by mini-css-extract-plugin
module.exports = {"title":"b50f7","copy":"_22b4e","wrapper":"f8442","block":"_7e263","header":"_7ec66","info":"_24fe3","quote":"ac088","image":"dc654","article":"ab9de","frame":"_10c94"};